import { createFileRoute } from '@tanstack/react-router';
import { i18next } from '@frontend/i18n';
import { FormPage } from '../pages';
import { normalizeCompanyIdParam } from '../utils/search-params.utils';

export interface SearchParams {
  formId?: string;
  packetId?: string;
  qwe?: string; // This will be the form/packet ID for solicited forms.
  companyId?: string;
  secretCode?: string; // Magic-link auto-verification code for solicited forms
  for_dependent?: string; // 'true' when the solicited link was generated for a dependent
  origin?: 'kiosk'; // Page was opened after collecting patron info in the kiosk new/existing-patron flow
}

export const Route = createFileRoute('/form')({
  component: FormPage,
  validateSearch: (search: SearchParams & { company_id?: string }): SearchParams => {
    return {
      ...normalizeCompanyIdParam<SearchParams>(search),
      origin: search.origin === 'kiosk' ? 'kiosk' : undefined,
    };
  },
  head: () => ({
    meta: [
      {
        title: i18next.t('Weave Forms', { ns: 'digital-forms-experience' }),
      },
    ],
    links: [
      {
        rel: 'preconnect',
        href: 'https://fonts.googleapis.com',
      },
      {
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com',
      },
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css2?family=Kaushan+Script&family=Fuzzy+Bubbles&family=Nothing+You+Could+Do&family=Caveat&display=swap',
      },
    ],
  }),
});
